import {
  BODY_TYPE_LABEL,
  LOADING_TYPE_LABEL,
  PAYMENT_TYPE_LABEL,
  formatMoney,
  type CargoListItem,
} from 'shared';

/**
 * Заявка обычным текстом — как её кидают в чаты логистов.
 *
 * Без разметки, чтобы вставлялось куда угодно; пустые поля пропускаются.
 * Одно место на всё приложение: и карточка, и лента копируют одинаково.
 */
export function cargoToText(
  c: CargoListItem & {
    comment?: string | null;
    loadDateTo?: string | null;
    vatIncluded?: boolean;
  },
): string {
  const d = (s?: string | null) =>
    s ? new Date(s).toLocaleDateString('ru-RU') : null;

  const body = [
    c.bodyTypes.map((b) => BODY_TYPE_LABEL[b]).join('/'),
    c.loadingTypes?.map((l) => LOADING_TYPE_LABEL[l]).join('/') || null,
    c.roadTrain ? 'сцепка' : null,
  ]
    .filter(Boolean)
    .join(', ');

  const load =
    c.loadDateTo && c.loadDateTo !== c.loadDateFrom
      ? `${d(c.loadDateFrom)} – ${d(c.loadDateTo)}`
      : d(c.loadDateFrom);

  return [
    `${c.fromAddress} → ${c.toAddress}${c.distanceKm ? `  (~${c.distanceKm} км)` : ''}`,
    `Груз: ${c.title}`,
    `Вес: ${(c.weightKg / 1000).toLocaleString('ru-RU')} т${
      c.volumeM3 ? ` · ${c.volumeM3} м³` : ''
    }`,
    body ? `Кузов: ${body}` : null,
    c.vehiclesCount > 1 ? `Машин: ${c.vehiclesCount}` : c.partial ? 'Догруз' : null,
    load ? `Погрузка: ${load}` : null,
    `Ставка: ${formatMoney(c.price, c.currency)} ${PAYMENT_TYPE_LABEL[c.paymentType]}${
      c.delayDays ? ` · отсрочка ${c.delayDays} дн` : ''
    }${c.vatIncluded ? ' · с НДС' : ''}`,
    c.advanceNote ? `Аванс: ${c.advanceNote}` : null,
    c.customsNote || null,
    c.comment ? `Комментарий: ${c.comment}` : null,
    `№ ${c.number}`,
  ]
    .filter(Boolean)
    .join('\n');
}
